namespace Gordic.Vyp.Lists
{
    @Decorators.gcontent
    export class GCenikDlg extends GContentBase<Wfl.ListAC.WflListBaseAC>
    {
        TypCeniku: Gordic.Wfl.Interface.TypCenikuPosty;
        model: Gordic.Wfl.Interface.GCenikPostyFiltrDto;
        data: Gordic.Wfl.Interface.GCenikPostyListDto[];
        KategorieCen: Gordic.Wfl.Interface.GCenikPostyKategorieDto[];
        view: Gordic.Data.View<Gordic.Wfl.Interface.GCenikPostyKategorieDto>;
        onContentReady()
        {
            const that = this;
            Wfl.ListAC.WflListBaseAC.InitList(this);
            //this.specialActions.push(this.CreateActionZmenaHodnot(true));

            Wfl.ListAC.WflListBaseAC.CompleteMenu(this);
            this.filterForm = $("<div>")
                .appendTo(this.element)
                .on("gfilterpanelapply", function (event, obj) {         // eventa která je vyvolána při vyhledávání. obj.filter -> hledaný seznam podmínek
                    that.LoadData(obj.filter);
                }).gfilterpanel({
                    forms: this.CreateFilterForm(), // poleFormu ktere budou pouzity pro podminky
                    // 01.03.2021 - TFeik
                    // Nahrazení obsolete parametrů.
                    filterViewMode: FilterViewMode.Simple,
                    //simpleMode: true,
                    favoriteLayoutDescriptor: Gordic.Gin.Globals.Enums.LayoutDescriptorType.list,
                });

            this.filterForm.gfilterpanel("applyFilter", $.extend(this.model), false)
        }

        ReloadData()
        {
            this.LoadData();
        }

        CreateFilterForm()
        {
            const that = this;
            const filterForm = new Gordic.Forms
                .Form({ name: "FormSPISPI", layoutDescriptor: "L1M1S1" })
                .addSection()
            filterForm.addRow("jres:23900022") //RC 23900022 : Stát
                .addField("gselectbox", "w-8", Gordic.Prefabs.Select.gincsta(), { name: "stat", model: "model.stat=value.stat" }) //RC 23900022 : Stát

            //this.defaultForm = $("<div>").appendTo(this.element).gform("createFrom", filterForm);
            that.findFields().gfield("model", "apply", this.model);
            return [filterForm];
        }

        CreateGrid(): void {
            const that = this;
            var gf = Gordic.Wfl.ListAC.WflListBaseAC.GetGridFormat();

            var l_labelNazev = "";
            switch (this.TypCeniku) {
                case Gordic.Wfl.Interface.TypCenikuPosty.cenikPostovnichSluzeb:
                    l_labelNazev = "jres:23900090";
                    break;
                case Gordic.Wfl.Interface.TypCenikuPosty.cenikZasilek:
                    l_labelNazev = "jres:23900097"; //RC 23900097 : Druh zásilky
                    break;
            }

            gf.addTextColumn({ name: "nazev", caption: l_labelNazev, width: 250 })  //RC 23900090 : Poštovní služby
            gf.addTextColumn({ name: "zkratka", caption: "jres:23900091", width: 70 })  //RC 23900091 : Zkratka

            for (var i = 0; i < this.KategorieCen.length; i++)
            {
                gf.addDecimalColumn({ name: "cena_" + i, caption: this.KategorieCen[i].nazev!, width: 100, format: "D2" });          
            }

            var OpenInfo = new GAction({     //obsluzna akce, ktera se spousti dbl clickem nad radkem
                name: "gridRowSelectedAct",
                run: function (ev, ctx) {
                    var rowData = ctx.cellInfo.data as Gordic.Wfl.Interface.GCenikPostyListDto; //data, ze kterych byl vytvoren radek
                    
                    if (ctx.cellInfo.column)
                    {
                        if (ctx.cellInfo.column.columnType == "number")
                        {
                            var l_det: Gordic.Wfl.Interface.GCenikPostyDetailDto = {}
                            var l_name = ctx.cellInfo.column.name as string;
                            var index = l_name.substring(l_name.length - 1, l_name.length);
                            l_det.id = rowData.id;
                            var l_cena = rowData["cena_" + index]
                            if (l_cena == undefined)
                            {
                                that.dialogs.warning("jres:23900102") //RC 23900102 : Tato hodnota není podporována pro tuto službu a stát.
                            }
                            else
                            {
                                l_det.vaha_do = rowData["vaha_do_" + index];
                                l_det.stat = that.model.stat;
                                l_det.typ = that.model.typ;
                                Gordic.Vyp.Dialogs.EditacePolozkyCenikuDlg(that, { Detail: l_det }, Gordic.Global.Enums.ModOtevreni.showModalWindow)
                                    .done(function (retVal) {
                                        debugger;
                                        if (retVal && retVal.cena)
                                        {
                                            rowData["cena_" + index] = new Decimal(retVal.cena).toFixed(2);
                                            Wfl.ListAC.WflListBaseAC.UpdateRowData(that, rowData);
                                            that.NeulozenaData = true;
                                            //hat.view.updateData(rowData, "update");
                                        }
                                    });
                            }
                        }
                    }
                }
            })

            this.gridOptions = {};
            this.gridOptions.defaultAction = OpenInfo;
            if (this.mainGrid) this.mainGrid.remove();
            var grid = Gordic.Wfl.ListAC.WflListBaseAC.CreateGridBase(this, gf);
            this.mainGrid = grid;
            Gordic.Wfl.ListAC.WflListBaseAC.AfterCreateGrid(this);
        }

        SetData()
        {
            if (this.data) {
                this.view = new Gordic.Data.View(this.data, { key: this.IDPrimaryKeyGridu });  //key je dulezity kvuli pripadnemu vyhledavani radku
                if (this.view && this.mainGrid && this.mainGrid.ggrid) this.mainGrid.ggrid("setData", this.view);
            }
        }

        LoadData(filtr?: Wfl.Interface.GCenikPostyFiltrDto)
        {
            var that = this;
            Gin.Globals.ShowWaitLoadData(this);
            //nacteni dat do gridu
            this.findFields().gfield("model", "collect", this.model);
            this.model = $.extend({}, this.model, filtr);
            if (filtr && filtr.stat)
            {
                this.call<Gordic.Wfl.Interface.GCenikPostyListDto[]>("LoadDataCeniku", { model: filtr })
                    .done(function (data) {

                        that.CreateGrid();
                        that.data = data;
                        that.SetData()
                    })
                    .always(function () {
                        that.endOperation();
                    });

            }
        }
    }
}
